<template>
  <div class="home">
   
    <!-- 该组件需要嵌套在el-dialog中 -->
    <el-dialog :visible.sync="showfalg" :title="title" :top="top" @close="dialogClose">
      <div class="top-image">
        <div class="top-left" @click="preview" v-show="dialogImage.length > 1">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="top-right" @click="next" v-show="dialogImage.length > 1">
          <i class="el-icon-arrow-right"></i>
        </div>
        <el-image
          :src="firstImages"
          fit="contain"
          style="width: 100%; height: 100%;box-shadow: 2px 2px 8px rgba(0, 0, 0, .5); "
          :preview-src-list="[firstImages]"
        ></el-image>
      </div>
      <div class="out-bottom" v-show="dialogImage.length > 1">
        <div
          class="bottom-image"
          v-for="(item, ind) in dialogImage"
          :key="ind"
          @click="chooseImage(item, ind)"
          :class="{ borderActive: previewImgIndex == ind ? 1 : 0 }"
        >
          <el-image
            style="
              width: 160px;
              height: 160px;
              border-radius: 6px;
              padding: 2px;
            "
            :src="item"
            fit="contain"
            :preview-src-list="dialogImage"
          ></el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    //回传回来的图片列表
    dialogImage: {
      type: Array,
      default: () => [],
    },
    //当前显示的图片
    firstImage: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
    //dialog的标题
    title:{
      type:String,
      default:""
    },
    //dialog距离顶部的距离
    top:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      previewImgIndex: 0,
      firstImages: "",
      dialogImages: [],
      showfalg: false,
    };
  },
  watch: {
    dialogImage: {
      handler: function (val) {
        this.dialogImages = val;
        this.firstImages = val[0];
      },
      deep: true,
      immediate: true,
    },
    // firstImage: {
    //   handler: function (val) {
    //     this.firstImages = val;
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    value(val) {
      this.showfalg = val;
    },
  },
  methods: {
    //下方滚动栏选择图片
    chooseImage(item, index) {
      this.firstImages = item;
      this.previewImgIndex = index;
    },
    //上一张
    preview() {
      let length = this.dialogImage.length;
      this.previewImgIndex = this.previewImgIndex - 1;
      if (this.previewImgIndex < 0) {
        this.previewImgIndex = length - 1;
      }
      this.firstImages = this.dialogImage[this.previewImgIndex];
    },
    //下一张
    next() {
      let length = this.dialogImage.length;
      this.previewImgIndex = this.previewImgIndex + 1;
      if (this.previewImgIndex > length - 1) {
        this.previewImgIndex = 0;
      }
      this.firstImages = this.dialogImage[this.previewImgIndex];
      // return;
    },
    //弹窗关闭通知父级一同更改属性
    dialogClose(){
      this.$emit("input",this.showfalg)
    }
  },
};
</script>

<style lang="scss" scoped>
.top-image {
  position: relative;
  width: 100%;
  height: 480px;
  margin-bottom: 20px;
  padding: 30px;
  box-sizing: border-box;
  .top-left {
    position: absolute;
    left: -20px;
    top: 240px;
    cursor: pointer;
    color: #409eff;
    font-size: 50px;
  }
  .top-right {
    position: absolute;
    right: -20px;
    top: 240px;
    cursor: pointer;
    color: #409eff;
    font-size: 50px;
  }
}
.out-bottom {
  width: 100%;
  height: 200px;
  .bottom-image {
    display: inline-block;
    border-radius: 6px;
    height: 163px;
    margin-right: 20px;
    cursor: pointer;
  }
  /deep/ .bottom-image:last-child {
    margin-right: 0;
  }
}
.borderActive {
  // border: 1px solid #1890ff;
  box-shadow: 4px 2px 6px rgba($color: #000000, $alpha: 0.5);
}
/deep/ .el-dialog__body {
  padding: 14px 20px;
}
</style>
